
<div >
    <!-- <div *ngIf="pollingLocationResults !== null && pollingLocationResults.length > 0" class="polling-container"> -->
        <table mat-table [dataSource]="dataSource" >
            <ng-container *ngFor="let col of columns; trackBy: trackByDistrictAndColumn; let i = index;" matColumnDef="{{col.column}}">
                <th mat-header-cell *matHeaderCellDef> 
                    <div *ngIf="col.isRightJustify===false">{{col.label}}</div>
                    <div class="value-justify-right" *ngIf="col.isRightJustify===true">{{col.label}}</div>
                    <br/>
                    <div *ngIf="col.isRightJustify===false" style="margin-top: -7px;">{{col.labelTwo}}</div>
                    <div class="value-justify-right" style="margin-top: -7px;" *ngIf="col.isRightJustify===true">{{col.labelTwo}}</div>
                    <br/>
                    <div *ngIf="col.colourCode!==null" class="value-justify-right" style="margin-left: -7px;" >
                        <mat-icon class="party-colour2" [ngStyle]="{'color': col.colourCode}">
                            rectangle
                        </mat-icon>
                    </div>
                </th>
                <td mat-cell *matCellDef="let element" >
                    <div *ngIf="col.isColour" [style.width.px]="col.minWidth">
                        <mat-icon class="party-colour" [ngStyle]="{'color': element.colourCode}">
                            rectangle
                        </mat-icon>
                    </div>
                    <div [style.min-width.px]="col.minWidth" class="value-justify-right"  *ngIf="col.isRightJustify&&col.isPercent===false">
                        {{element[col.column]|number}}
                    </div>
                    <div [style.min-width.px]="col.minWidth" class="value-justify-right"  *ngIf="col.isPercent">
                        <div *ngIf="col.isColourBar">
        
                        </div>
                        {{(element[col.column]===null?'n/a':element[col.column])/100|percent :'1.1-1'}}
                    </div>
                    <div [style.min-width.px]="col.minWidth" *ngIf="col.isRightJustify===false&&col.isColour===false">{{element[col.column]}}</div>
                </td>
            </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" ></tr>
        </table>
    <!-- </div>
    <div *ngIf="!pollingLocationResults || pollingLocationResults.length==0">Data not available!</div> -->
</div>


<!-- <table mat-table [dataSource]="dataSource" matSort class="data-grid">
    <ng-container *ngFor="let column of header; let i=index;" matColumnDef="{{column.name}}">
      <th style="margin-right: 10px" mat-header-cell *matHeaderCellDef mat-sort-header>
        {{column.label}}
      </th>
      <td mat-cell *matCellDef="let datarow" [title]="hasExtraDetails[i] ? datarow[column.name + '_details'] : ''">
        {{ isADate[i] === false ? datarow[column.name] : datarow[column.name] | date:'EEE, d MMM y, H:mm:ss' }}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table> -->